import { Injectable } from '@angular/core';
import { CustomBasePageMetaResolver } from '@core/feature';
import {
  BreadcrumbMeta,
  CanonicalPageResolver,
  Page,
  PageBreadcrumbResolver,
  PageDescriptionResolver,
  PageMetaResolver,
  PageRobotsMeta,
  PageRobotsResolver,
  PageTitleResolver,
  PageType,
  PageTypeResolver,
  SemanticPathService,
} from '@spartacus/core';
import { Observable, combineLatest, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AccountPageMetaResolver
  extends PageMetaResolver
  implements
    PageTitleResolver,
    PageBreadcrumbResolver,
    PageDescriptionResolver,
    PageRobotsResolver,
    CanonicalPageResolver,
    PageTypeResolver
{
  pageId = 'myAccountPage';

  private myAccountBreadcrumb$: Observable<BreadcrumbMeta[]> = of([
    { label: 'Мой аккаунт', link: this.semanticPathService.get('myAccount') },
  ]);
  private myAccountDetailBreadcrumb$: Observable<BreadcrumbMeta[]> = this.resolveTitle().pipe(
    map((name) => [{ label: name }] as BreadcrumbMeta[]),
  );

  constructor(
    private basePageMetaResolver: CustomBasePageMetaResolver,
    private semanticPathService: SemanticPathService,
  ) {
    super();

    this.pageType = PageType.CONTENT_PAGE;
    this.pageTemplate = 'AccountPageTemplate';
  }

  resolveTitle(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveTitle();
  }

  resolveDescription(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveDescription();
  }

  resolveRobots(): Observable<PageRobotsMeta[]> {
    return this.basePageMetaResolver.resolveRobots();
  }

  resolveCanonicalUrl(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveCanonicalUrl();
  }

  resolveType(): Observable<string> {
    return this.basePageMetaResolver.resolveType();
  }

  getScore(page: Page): number {
    return page.pageId !== this.pageId && page.template === this.pageTemplate ? super.getScore(page) + 1 : 0;
  }

  resolveBreadcrumbs(): Observable<BreadcrumbMeta[] | undefined> {
    return combineLatest({
      breadcrumbs: this.basePageMetaResolver.resolveBreadcrumbs(),
      myAccountBreadcrumb: this.myAccountBreadcrumb$,
      myAccountDetailBreadcrumb: this.myAccountDetailBreadcrumb$,
    }).pipe(
      map(({ breadcrumbs, myAccountBreadcrumb, myAccountDetailBreadcrumb }) => [
        ...breadcrumbs.slice(0, 1),
        ...myAccountBreadcrumb,
        ...myAccountDetailBreadcrumb,
      ]),
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }
}
